import React, { ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { RouteComponentProps } from '../../../helpers/withRouter'
import { Dispatch, AnyAction} from 'redux'
import { Button, MenuItem, Page, Spinner } from '../../../components'
import { images } from '../../../images'
import { AuthenticatedRoutable, IBase } from '../../../models'
import literalsService from '../../../services/literals-service'
import { fetchAreasAction, fetchClientInfoAction, fetchServicesAction, setAreaChangedAction, setNotificationAction, setSelectedAreaAction, setUserInfoAction } from '../../../store/actions'
import { IStoreState } from '../../../store/states'
import { UserService } from '../../../services'
import StyledArticle from './styles'
import { appsStyleSelected } from '../../../helpers/app'

interface IProps extends RouteComponentProps, DispatchProp<any> {
  userTown: IBase
  isFetchingAreas: boolean
  areas: any[]
  selectedAreaId: number | null
  isLoadingUserInfo: boolean
}

class AreaSelection extends AuthenticatedRoutable<IProps> {

  private get areas(): ReactNode {
    const { areas, selectedAreaId } = this.props
    const areaItems = areas.sort((a, b) => a.name.localeCompare(b.name)).map(area => (
      <section key={area.id} className='row'>
        <MenuItem
          label={area.name}
          onClick={ () => this.handleAreaSelection(area.id) }
          icon={selectedAreaId === area.id ? 'checkLanguage' : undefined}
          key={area.id}
        />
      </section>
    ))

    if (areas && areas.length) {
      return (
        <section>
          <h3>{ literalsService.get('areaSelection', true) }</h3>
          <section>
            { areaItems }
          </section>
        </section>
      )
    } else return null
  }

  public componentDidMount() {
    const { dispatch, userTown, selectedAreaId } = this.props
    super.componentDidMount()

    if (userTown) {
      dispatch(fetchAreasAction())
      if (!selectedAreaId) dispatch(setSelectedAreaAction(userTown.id))
    }
  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    const { dispatch, userTown, selectedAreaId } = this.props
    if (prevProps.userTown.id !== userTown.id) {
      dispatch(fetchAreasAction())
      if (!selectedAreaId) dispatch(setSelectedAreaAction(userTown.id))
    }
  }

  public render(): ReactNode {

    const { isFetchingAreas, selectedAreaId, isLoadingUserInfo, dispatch } = this.props
    return (
      <Page>
        <Page className={`authenticated ${appsStyleSelected?.style}`}>
          <StyledArticle>
            {
              isFetchingAreas || isLoadingUserInfo ?
              <article className="spinner-container">
                <Spinner />
              </article>
              :
              <>
                <img src={ images['goBack'] } className='backButton' onClick={ this.handleGoBack } />
                { this.areas }
                <Button
                  title={ literalsService.get('save', true) }
                  onPress={ () => this.saveArea(selectedAreaId, dispatch) }
                  className={ 'saveButton' }
                  filled
                  upper
                />
              </>
            }
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private handleGoBack = (): void => {
    this.handleAreaSelection(this.props.userTown.id)
    history.back()
  }

  private handleAreaSelection = (areaId: any) => {
    this.props.dispatch(setSelectedAreaAction(areaId))
  }

  private async saveArea(id: number | null, dispatch: Dispatch): Promise<void> {
    if (!id) return

    try {
      await UserService.updateTown(id)
      const user = await UserService.getInfo()
      dispatch(setUserInfoAction(user))
      dispatch(fetchClientInfoAction())
      dispatch(setAreaChangedAction())
      dispatch(fetchServicesAction())
      history.back()
      dispatch(
        setNotificationAction({
          isError: false,
          label: literalsService.get('areaChanged', true)
        })
      )
    } catch (error) {
      dispatch(
        setNotificationAction({
          isError: true,
          label: literalsService.get('serverError', true)
        })
      )
    }
  }
}

const mapStateToProps = ({ configuration, userInfo }: IStoreState) => ({
  userTown: userInfo.town,
  isFetchingAreas: configuration.isFetchingAreas,
  areas: configuration.areas,
  selectedAreaId: configuration.selectedAreaId,
  isLoadingUserInfo: userInfo.isLoadingUserInfo
})

export default connectRedux(mapStateToProps, AreaSelection)

